import { Link } from 'react-router-dom'
import { RiHomeLine, RiCalendarCheckLine } from 'react-icons/ri'
import SEO from '../../components/seo/SEO'

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" path="/404" noIndex />
      <section className="min-h-[80vh] bg-hero-gradient flex items-center">
        <div className="container-salon text-center py-24">
          <p className="font-display text-salon-secondary text-7xl md:text-9xl font-bold mb-4">404</p>
          <h1 className="font-display text-white text-3xl md:text-4xl font-bold mb-4">
            We couldn't find that page
          </h1>
          <p className="text-white/70 font-body max-w-md mx-auto mb-8">
            The link may be broken or the page may have moved. Let's get you back on track.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn-gold"><RiHomeLine /> Back to Home</Link>
            <Link to="/book" className="btn-secondary border-white text-white hover:bg-white hover:text-salon-primary">
              <RiCalendarCheckLine /> Book Appointment
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
